module.exports = __webpack_public_path__ + "b7a9c7656aea5a84fa70a9615e3f62c8.jpg";